import { InfoOutlined } from "@mui/icons-material";
import { Container, Card, Typography, TextField, Alert } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "../../../../hooks/useTranslation";
import { CountrySelect } from "../components/country-select/CountrySelect";

export const AddStore = () => {
  const { translate } = useTranslation("pages.stores.create");
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Container
        component={Card}
        sx={{
          padding: "24px",
          marginBottom: "16px",
        }}
      >
        <Typography variant="body1" fontWeight={"bold"}>
          {translate("name.description")}
        </Typography>
        <TextField
          label={translate("name.label")}
          sx={{ width: "60%", marginTop: "16px" }}
          size="small"
          error={!!errors.name}
          helperText={errors.name ? translate("name.error") : ""}
          {...register("name", { required: true })}
        />
      </Container>

      <Container
        component={Card}
        sx={{ padding: "24px", marginBottom: "16px" }}
      >
        <Typography variant="body1" fontWeight={"bold"}>
          {translate("marketplace.description")}
        </Typography>
        <Typography variant="body2">
          {translate("marketplace.description2")}
        </Typography>
        <Typography variant="body2">
          {translate("marketplace.description3")}
        </Typography>
        <CountrySelect />
      </Container>

      <Container
        component={Card}
        sx={{ padding: "24px 0px", marginBottom: "16px" }}
      >
        <Alert icon={<InfoOutlined fontSize="inherit" />} severity="info">
          <Typography variant="body1" fontWeight={"bold"}>
            {translate("managementInfo.title")}
          </Typography>
          <Typography variant="body2">
            {translate("managementInfo.description")}
          </Typography>
          <Typography variant="body2">
            {translate("managementInfo.description2")}
          </Typography>
        </Alert>
      </Container>
    </>
  );
};
